<template>
  <ViewWrapper class="dashboard_view" :scrollable="true">
    <DashboardKpiOverview />

    <!-- just placeholder by now -->
    <ButtonPill class="dashboard_view__back-to-start" :to="{ name: 'addToGlobe' }" replace>
      {{ $t('view.dashboard.addPerformanceToGlobe') }}
    </ButtonPill>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '../components/ViewWrapper';
import DashboardKpiOverview from '../components/Dashboard/KpiOverview';
import ButtonPill from '../components/ButtonPill';

export default {
  name: 'DashboardView',

  components: {
    ViewWrapper,
    DashboardKpiOverview,
    ButtonPill,
  },
};
</script>

<style lang="scss" scoped>
.dashboard_view {
  background-color: rgba($color-background, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-background);
  overflow-x: hidden;

  // Center content vertically. Additional div inside this element is not possible because
  // it wouldn't have 100% height.
  display: flex;
  flex-direction: column;
  justify-content: center;

  ::v-deep {
    .view-wrapper__content {
      flex: 1;
    }
  }
}

.dashboard_view__back-to-start {
  width: 240px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: calc(20px + env(safe-area-inset-bottom));

  @include helper__greater($bp-1024) {
    margin-top: 80px;
  }
}
</style>
